module.exports = __webpack_public_path__ + "static/condo-7-1067c7e76f94a68a5cc5ff04d7f59187.jpg";